import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationPayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_22134_2152)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20 0.5C16.0444 0.5 12.1776 1.67298 8.8886 3.87061C5.59962 6.06824 3.03617 9.19181 1.52242 12.8463C0.00866571 16.5009 -0.387401 20.5222 0.384303 24.4018C1.15601 28.2814 3.06082 31.8451 5.85787 34.6421C8.65492 37.4392 12.2186 39.344 16.0982 40.1157C19.9778 40.8874 23.9992 40.4913 27.6537 38.9776C31.3082 37.4638 34.4318 34.9004 36.6294 31.6114C38.827 28.3224 40 24.4556 40 20.5C39.9943 15.1974 37.8853 10.1137 34.1358 6.3642C30.3863 2.61471 25.3026 0.505735 20 0.5ZM20 37.1667C16.7037 37.1667 13.4813 36.1892 10.7405 34.3578C7.99969 32.5265 5.86348 29.9235 4.60202 26.8781C3.34056 23.8326 3.0105 20.4815 3.65359 17.2485C4.29667 14.0155 5.88402 11.0458 8.2149 8.71489C10.5458 6.38401 13.5155 4.79667 16.7485 4.15358C19.9815 3.51049 23.3326 3.84055 26.3781 5.10201C29.4235 6.36347 32.0265 8.49968 33.8578 11.2405C35.6892 13.9813 36.6667 17.2036 36.6667 20.5C36.6618 24.9188 34.9043 29.1552 31.7798 32.2798C28.6552 35.4043 24.4188 37.1618 20 37.1667ZM17.7076 12.9914C17.5959 11.6502 18.6542 10.5 20 10.5C21.3458 10.5 22.4041 11.6502 22.2924 12.9914L21.3538 24.2543C21.2951 24.9584 20.7065 25.5 20 25.5C19.2935 25.5 18.7049 24.9584 18.6462 24.2543L17.7076 12.9914ZM20 28C21.3807 28 22.5 29.1193 22.5 30.5C22.5 31.8807 21.3807 33 20 33C18.6193 33 17.5 31.8807 17.5 30.5C17.5 29.1193 18.6193 28 20 28Z",
			fill: "#E69D15"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22134_2152",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgExclamationPayment;
